import { render } from "./SalesOverviewChart.vue?vue&type=template&id=a128eea0&ts=true"
import script from "./SalesOverviewChart.vue?vue&type=script&lang=ts"
export * from "./SalesOverviewChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__